module.exports = __webpack_public_path__ + "img/youshi10.809df595.png";